module.exports = __webpack_public_path__ + "static/img/cockatrice.ad7b809.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/cockatrice.png
// module id = 733F
// module chunks = 0